import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'

// Axios
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios);

//GA
import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
    id: 'UA-166899382-1',
    router,
    batch: {
        enabled: true, // enable/disable
        amount: 2, // amount of events fired
        delay: 500 // delay in milliseconds
    }
})

Vue.config.productionTip = false;
Vue.use(Argon);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
